export enum EntityType {
  // Base Entities (10)
  PHANTOM = 'PHANTOM',
  PORTAL = 'PORTAL',
  BARRIER = 'BARRIER',
  ORB = 'ORB',
  CRYSTAL = 'CRYSTAL',
  ROCK = 'ROCK',
  WATER = 'WATER',
  FIRE = 'FIRE',
  KEY = 'KEY',
  DOOR = 'DOOR',
  
  // Advanced Entities (10)
  ICE = 'ICE',           // Frozen blocks - slippery
  LAVA = 'LAVA',         // Molten rock - destructive
  MIRROR = 'MIRROR',     // Reflective surface - reverses
  VOID = 'VOID',         // Empty space - teleports
  BOLT = 'BOLT',         // Lightning - moves fast
  STAR = 'STAR',         // Celestial body - floats
  SKULL = 'SKULL',       // Danger - deadly
  COIN = 'COIN',         // Collectible - value
  GHOST = 'GHOST',       // Ethereal - passes through
  STATUE = 'STATUE',     // Monument - immovable
  
  // Enemy Types (5) - Spawn on excessive dimension switching
  HUNTER = 'HUNTER',     // Tracks and follows player
  WATCHER = 'WATCHER',   // Observes and spawns on excess phasing
  SHADOW = 'SHADOW',     // Mimics player movements
  PURSUER = 'PURSUER',   // Fast chaser - appears after threshold
  SENTINEL = 'SENTINEL', // Guardian that blocks dimension travel
  
  // Word Nouns (10 base)
  WORD_PHANTOM = 'WORD_PHANTOM',
  WORD_PORTAL = 'WORD_PORTAL',
  WORD_BARRIER = 'WORD_BARRIER',
  WORD_ORB = 'WORD_ORB',
  WORD_CRYSTAL = 'WORD_CRYSTAL',
  WORD_ROCK = 'WORD_ROCK',
  WORD_WATER = 'WORD_WATER',
  WORD_FIRE = 'WORD_FIRE',
  WORD_KEY = 'WORD_KEY',
  WORD_DOOR = 'WORD_DOOR',
  
  // Word Nouns (10 advanced)
  WORD_ICE = 'WORD_ICE',
  WORD_LAVA = 'WORD_LAVA',
  WORD_MIRROR = 'WORD_MIRROR',
  WORD_VOID = 'WORD_VOID',
  WORD_BOLT = 'WORD_BOLT',
  WORD_STAR = 'WORD_STAR',
  WORD_SKULL = 'WORD_SKULL',
  WORD_COIN = 'WORD_COIN',
  WORD_GHOST = 'WORD_GHOST',
  WORD_STATUE = 'WORD_STATUE',
  
  // Word Nouns (5 enemies)
  WORD_HUNTER = 'WORD_HUNTER',
  WORD_WATCHER = 'WORD_WATCHER',
  WORD_SHADOW = 'WORD_SHADOW',
  WORD_PURSUER = 'WORD_PURSUER',
  WORD_SENTINEL = 'WORD_SENTINEL',
  
  // Word Connector
  WORD_IS = 'WORD_IS',
  
  // Word Properties (13 base)
  WORD_YOU = 'WORD_YOU',
  WORD_WIN = 'WORD_WIN',
  WORD_STOP = 'WORD_STOP',
  WORD_PUSH = 'WORD_PUSH',
  WORD_PHASE = 'WORD_PHASE',
  WORD_SINK = 'WORD_SINK',
  WORD_HOT = 'WORD_HOT',
  WORD_MELT = 'WORD_MELT',
  WORD_OPEN = 'WORD_OPEN',
  WORD_SHUT = 'WORD_SHUT',
  WORD_MOVE = 'WORD_MOVE',
  WORD_DEFEAT = 'WORD_DEFEAT',
  WORD_TRANSFORM = 'WORD_TRANSFORM',
  
  // Word Properties (10 advanced)
  WORD_FLOAT = 'WORD_FLOAT',       // Ignores gravity/water
  WORD_SLIP = 'WORD_SLIP',         // Slides continuously
  WORD_TELE = 'WORD_TELE',         // Teleports randomly
  WORD_CLONE = 'WORD_CLONE',       // Duplicates entity
  WORD_SWAP = 'WORD_SWAP',         // Swaps positions
  WORD_WEAK = 'WORD_WEAK',         // Can be destroyed easily
  WORD_STRONG = 'WORD_STRONG',     // Cannot be destroyed
  WORD_PULL = 'WORD_PULL',         // Pulls entities toward
  WORD_FALL = 'WORD_FALL',         // Falls through gaps
  WORD_REVERSE = 'WORD_REVERSE',   // Reverses movement
  
  // Word Properties (5 enemy behaviors)
  WORD_HUNT = 'WORD_HUNT',         // Actively chases player
  WORD_TRACK = 'WORD_TRACK',       // Follows through dimensions
  WORD_MIMIC = 'WORD_MIMIC',       // Copies player actions
  WORD_GUARD = 'WORD_GUARD',       // Prevents dimension switching
  WORD_ALERT = 'WORD_ALERT'        // Triggers on excessive phasing
}

export interface EntityData {
  type: string;
  x: number;
  y: number;
}

export interface WordBoxData {
  type: string;
  x: number;
  y: number;
}

export interface Level {
  name: string;
  entities: EntityData[];
  wordBoxes: {
    [key: number]: WordBoxData[];
  };
}

export interface Rule {
  noun: string;
  property: string;
  dimension: number;
}

export interface DimensionData {
  wordBoxes: any[];
  connectedWords: any[];
}

export interface GameState {
  currentLevel: number;
  currentDimension: number;
  rules: Rule[];
  gameWon: boolean;
  isAnimating: boolean;
  completedLevels: number[];
}
